var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7513 3.58398H23.293L35.8346 16.1257V35.834C35.8346 36.7843 35.4571 37.6958 34.7851 38.3678C34.1131 39.0398 33.2017 39.4173 32.2513 39.4173H10.7513C9.80094 39.4173 8.88951 39.0398 8.2175 38.3678C7.5455 37.6958 7.16797 36.7843 7.16797 35.834V7.16732C7.16797 6.21696 7.5455 5.30552 8.2175 4.63352C8.88951 3.96151 9.80094 3.58398 10.7513 3.58398Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.293 3.58398V16.1257H35.8346",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7daaa17dc98fe9020e57bb2676a569ff.svg";
export { ForwardRef as ReactComponent };